import CitizenshipStatus from '@screens/review-section3/review/citizenship-status';
import { createTranslationService } from '@services/factories';
import { IRemoteRepresentativeStore } from '@stores/remote-representative/remote-representative-store';
import { cacheTranslations } from '@utils/cache-translations';
import { observer } from 'mobx-react';
import * as React from 'react';
import {
    DetailsCell,
    DetailsColumnContainer,
    DetailsContainer
} from './details-styles';

interface Props {
    store: IRemoteRepresentativeStore;
}

enum EmployeeDetailsTranslation {
    firstName = 'firstName',
    lastName = 'lastName',
    familyName = 'familyName',
    givenName = 'givenName',
    middleInitial = 'middleInitial',
    citizenshipStatus = 'citizenshipStatus',
    employeeFirstEmploymentDate = 'employeeFirstEmploymentDate',
    naLabel = 'naLabel'
}

const EmployeeDetails = ({ store }: Props) => {
    const translations = cacheTranslations(
        createTranslationService(),
        EmployeeDetailsTranslation
    );

    return (
        <DetailsContainer>
            <DetailsColumnContainer flex={160}>
                <DetailsCell>{translations.lastName}<i>{translations.familyName}</i></DetailsCell>
                <DetailsCell>{translations.firstName}<i>{translations.givenName}</i></DetailsCell>
                <DetailsCell>{translations.middleInitial}</DetailsCell>
                <DetailsCell>{translations.citizenshipStatus}</DetailsCell>
            </DetailsColumnContainer>
            <DetailsColumnContainer>
                <DetailsCell>{store.remoteI9Details?.candidateDetails?.lastName ?? translations.naLabel}</DetailsCell>
                <DetailsCell>{store.remoteI9Details?.candidateDetails?.firstName ?? translations.naLabel}</DetailsCell>
                <DetailsCell>{store.remoteI9Details?.candidateDetails?.middleInitial ?? translations.naLabel}</DetailsCell>
                <DetailsCell>
                    <CitizenshipStatus status={store.remoteI9Details?.candidateDetails?.citizenshipStatus}
                                       fallbackLabel={translations.naLabel} />
                </DetailsCell>
            </DetailsColumnContainer>
        </DetailsContainer>
    );
};

export default observer(EmployeeDetails);



// WEBPACK FOOTER //
// ./src/screens/review-section3/review/employee-details.tsx